const huge_bat = (level) => {
  const handle = 'huge_bat';
  const types = ['flying', 'beast', 'bat'];
  const AI_PRIORITIES = ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'];
  const bags = [];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'huge_bat_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          quickness: {
            handle: 'quickness',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          freedom: {
            handle: 'freedom',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(1 + bound_level * 0.25 + Math.random() * 3),
      perception: Math.round(2 + bound_level * 1 + Math.random() * 3),
      mana: Math.round(1 + bound_level * 0.25 + Math.random() * 3),
      toughness: Math.round(2 + bound_level * 0.65 + Math.random() * 3),
      strength: Math.round(1 + bound_level * 0.5 + Math.random() * 3),
      willpower: Math.round(1 + bound_level * 0.25 + Math.random() * 3),
      dexterity: Math.round(1 + bound_level * 0.75 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 20,
    drops_gold: false,
    drops_equipment: false,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: {},
      equipped_abilities: [{ value: 'move' }, { value: 'melee_attack' }],
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = huge_bat;
